import { render, staticRenderFns } from "./BottomDialog.vue?vue&type=template&id=8d4b1fcc&scoped=true&lang=pug&"
import script from "./BottomDialog.vue?vue&type=script&lang=js&"
export * from "./BottomDialog.vue?vue&type=script&lang=js&"
import style0 from "./BottomDialog.vue?vue&type=style&index=0&id=8d4b1fcc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d4b1fcc",
  null
  
)

component.options.__file = "BottomDialog.vue"
export default component.exports